import { render, staticRenderFns } from "./TicketsCreate.vue?vue&type=template&id=fb9be0f2"
import script from "./TicketsCreate.vue?vue&type=script&lang=js"
export * from "./TicketsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports